"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barcodeLabelDescriptions = exports.barcodeLayouts = exports.DEFAULT_LABEL_PAGE_LAYOUT_TYPE = exports.LabelLayoutType = exports.THERMAL_4_X_2_LAYOUT = void 0;
const INCHES_TO_POINTS = 72;
const MM_TO_POINTS = 2.8346456693;
const mmToPoints = (mm) => Math.round(mm * MM_TO_POINTS);
const A4_PAPER_SIZE = {
    paperWidth: 595,
    paperHeight: 841,
};
const AVERY_30_UP_LAYOUT = {
    paperWidth: 8.5 * INCHES_TO_POINTS,
    paperHeight: 11 * INCHES_TO_POINTS,
    labelWidth: 2.625 * INCHES_TO_POINTS,
    labelHeight: INCHES_TO_POINTS,
    marginLeft: 0.1725 * INCHES_TO_POINTS,
    marginTop: 0.5 * INCHES_TO_POINTS,
    columnMargin: 0.14 * INCHES_TO_POINTS,
    rowMargin: 0,
    columns: 3,
    labelsPerPage: 30,
};
const A4_21_UP_63_X_38_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(63.5), labelHeight: mmToPoints(38.1), marginLeft: mmToPoints(7.25), marginTop: mmToPoints(15.15), columnMargin: mmToPoints(2.5), rowMargin: 0, columns: 3, labelsPerPage: 21 });
const A4_24_UP_63_X_33_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(63.5), labelHeight: mmToPoints(33.9), marginLeft: mmToPoints(7.25), marginTop: mmToPoints(12.9), columnMargin: mmToPoints(2.5), rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_24_UP_64_X_33_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(64.6), labelHeight: mmToPoints(33.8), marginLeft: mmToPoints(7.5), marginTop: mmToPoints(13.3), columnMargin: mmToPoints(2), rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_24_UP_66_X_33_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(66), labelHeight: mmToPoints(33.9), marginLeft: mmToPoints(6), marginTop: mmToPoints(12.9), columnMargin: 0, rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_24_UP_66_X_35_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(66), labelHeight: mmToPoints(35), marginLeft: mmToPoints(6), marginTop: mmToPoints(12.9), columnMargin: mmToPoints(0.75), rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_24_UP_70_X_36_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(70), labelHeight: mmToPoints(36), marginLeft: 0, marginTop: mmToPoints(4.5), columnMargin: 0, rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_24_UP_70_X_37_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(63.5), labelHeight: mmToPoints(33.9), marginLeft: mmToPoints(7.25), marginTop: mmToPoints(12.9), columnMargin: mmToPoints(2.5), rowMargin: 0, columns: 3, labelsPerPage: 24 });
const A4_27_UP_63_X_29_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(63.5), labelHeight: mmToPoints(29.6), marginLeft: mmToPoints(7.75), marginTop: mmToPoints(15.3), columnMargin: mmToPoints(2), rowMargin: 0, columns: 3, labelsPerPage: 27 });
const A4_40_UP_52_X_29_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(52.5), labelHeight: mmToPoints(29.7), marginLeft: 0, marginTop: 0, columnMargin: 0, rowMargin: 0, columns: 4, labelsPerPage: 40 });
const A4_44_UP_48_X_25_LAYOUT = Object.assign(Object.assign({}, A4_PAPER_SIZE), { labelWidth: mmToPoints(48.5), labelHeight: mmToPoints(25.4), marginLeft: mmToPoints(8), marginTop: mmToPoints(8.8), columnMargin: mmToPoints(0), rowMargin: 0, columns: 4, labelsPerPage: 44 });
exports.THERMAL_4_X_2_LAYOUT = {
    paperWidth: 4.125 * INCHES_TO_POINTS,
    paperHeight: INCHES_TO_POINTS,
    labelWidth: 4 * INCHES_TO_POINTS,
    labelHeight: INCHES_TO_POINTS,
    marginLeft: 0.0625 * INCHES_TO_POINTS,
    marginTop: 0.0625 * INCHES_TO_POINTS,
    columnMargin: 0,
    rowMargin: 0,
    columns: 1,
    labelsPerPage: 1,
};
var LabelLayoutType;
(function (LabelLayoutType) {
    LabelLayoutType["A4_21_UP_63_X_38"] = "A4_21_UP_63_X_38";
    LabelLayoutType["A4_24_UP_63_X_33"] = "A4_24_UP_63_X_33";
    LabelLayoutType["A4_24_UP_64_X_33"] = "A4_24_UP_64_X_33";
    LabelLayoutType["A4_24_UP_66_X_33"] = "A4_24_UP_66_X_33";
    LabelLayoutType["A4_24_UP_66_X_35"] = "A4_24_UP_66_X_35";
    LabelLayoutType["A4_24_UP_70_X_36"] = "A4_24_UP_70_X_36";
    LabelLayoutType["A4_24_UP_70_X_37"] = "A4_24_UP_70_X_37";
    LabelLayoutType["A4_27_UP_63_X_29"] = "A4_27_UP_63_X_29";
    LabelLayoutType["A4_40_UP_52_X_29"] = "A4_40_UP_52_X_29";
    LabelLayoutType["A4_44_UP_48_X_25"] = "A4_44_UP_48_X_25";
    LabelLayoutType["AVERY_30_UP"] = "AVERY_30_UP";
    LabelLayoutType["THERMAL_4_X_2"] = "THERMAL_4_X_2";
})(LabelLayoutType = exports.LabelLayoutType || (exports.LabelLayoutType = {}));
exports.DEFAULT_LABEL_PAGE_LAYOUT_TYPE = LabelLayoutType.AVERY_30_UP;
exports.barcodeLayouts = {
    [LabelLayoutType.A4_21_UP_63_X_38]: A4_21_UP_63_X_38_LAYOUT,
    [LabelLayoutType.A4_24_UP_63_X_33]: A4_24_UP_63_X_33_LAYOUT,
    [LabelLayoutType.A4_24_UP_64_X_33]: A4_24_UP_64_X_33_LAYOUT,
    [LabelLayoutType.A4_24_UP_66_X_33]: A4_24_UP_66_X_33_LAYOUT,
    [LabelLayoutType.A4_24_UP_66_X_35]: A4_24_UP_66_X_35_LAYOUT,
    [LabelLayoutType.A4_24_UP_70_X_36]: A4_24_UP_70_X_36_LAYOUT,
    [LabelLayoutType.A4_24_UP_70_X_37]: A4_24_UP_70_X_37_LAYOUT,
    [LabelLayoutType.A4_27_UP_63_X_29]: A4_27_UP_63_X_29_LAYOUT,
    [LabelLayoutType.A4_40_UP_52_X_29]: A4_40_UP_52_X_29_LAYOUT,
    [LabelLayoutType.A4_44_UP_48_X_25]: A4_44_UP_48_X_25_LAYOUT,
    [LabelLayoutType.AVERY_30_UP]: AVERY_30_UP_LAYOUT,
    [LabelLayoutType.THERMAL_4_X_2]: exports.THERMAL_4_X_2_LAYOUT,
};
exports.barcodeLabelDescriptions = {
    [LabelLayoutType.A4_21_UP_63_X_38]: "21-up labels 63.5 x 38.1 mm on A4",
    [LabelLayoutType.A4_24_UP_63_X_33]: "24-up labels 63.5 x 33.9 mm on A4",
    [LabelLayoutType.A4_24_UP_64_X_33]: "24-up labels 64.6 x 33.8 mm on A4",
    [LabelLayoutType.A4_24_UP_66_X_33]: "24-up labels 66 x 33.9 mm on A4",
    [LabelLayoutType.A4_24_UP_66_X_35]: "24-up labels 66 x 35 mm on A4",
    [LabelLayoutType.A4_24_UP_70_X_36]: "24-up labels 70 x 36 mm on A4",
    [LabelLayoutType.A4_24_UP_70_X_37]: "24-up labels 70 x 37 mm on A4",
    [LabelLayoutType.A4_27_UP_63_X_29]: "27-up labels 63.5 x 29.6 mm on A4",
    [LabelLayoutType.AVERY_30_UP]: `30-up labels 1" x 2-5/8" on US Letter`,
    [LabelLayoutType.A4_40_UP_52_X_29]: "40-up labels 52.5 x 29.7 mm on A4",
    [LabelLayoutType.A4_44_UP_48_X_25]: "44-up labels 48.5 x 25.4 mm on A4",
};
//# sourceMappingURL=BarcodeLayouts.js.map